export default __webpack_public_path__ + "static/media/illustration-canada.52886c45.svg";